<template>
    <div id="app">
        <header-nav />
        <router-view/>
        <footer-nav />
    </div>
</template>

<script>
import Logos from '@/components/misc/Logos'
import HeaderNav from '@/components/navigation/Header'
import FooterNav from '@/components/navigation/Footer'

export default {
	name: 'App',
	components: {
		HeaderNav,
		FooterNav,
		Logos
	}
}

window.onload = function() {
	growShrinkLogo()
}

window.onscroll = function() {
	growShrinkLogo()
}

window.onresize = function() {
	growShrinkLogo()
}

function growShrinkLogo() {
	var logo = document.getElementById('logo')
	var width = document.body.clientWidth

	if (width > 990) {
		if (
			document.body.scrollTop > 400 ||
			document.documentElement.scrollTop > 400
		) {
			logo.style.width = '200px'
		} else {
			logo.style.width = '316px'
		}
	} else {
		logo.style.width = '200px'
	}
}
</script>

<style lang="scss">
@import './assets/scss/styles.scss';
</style>


// WEBPACK FOOTER //
// src/App.vue